import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgLj = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.337 14.097a5.113 5.113 0 00-2.63 2.644l3.321.686-.689-3.33h-.002zm-14.07-6.88a8.758 8.758 0 014.529-4.55L8.72 4.582a8.73 8.73 0 013.47-.716c4.828 0 8.742 3.91 8.742 8.734s-3.914 8.733-8.741 8.733c-4.83 0-8.743-3.907-8.743-8.733 0-1.238.276-2.397.74-3.462l7.112 7.089a8.763 8.763 0 014.529-4.55L8.725 4.583a8.767 8.767 0 00-4.536 4.55L2.267 7.217z"
      clipRule="evenodd"
    />
  </svg>
));
SvgLj.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgLj;
